
import TiwiMixin from '../../mixins/TiwiMixin';
import FollowButton from '../FollowButton.vue';
import ModalPopup from '../ModalPopup';

export default {
    mixins: [TiwiMixin],
    components: {
        ModalPopup
    },
    props: {
        onSubmit: {
            required: false,
            default: () => { },
            type: Function
        },
        enableSearch: {
            required: false,
            default: 1,
            type: Number
        }
    },
    data() {
        return {
            showModal: false,
            isFollowingScreen: true,
            followings: [],
            followers: [],
            followings_count: '',
            followers_count: '',
            mail_search: '',
            mail_search_result: null,
        }
    },
    mounted: function () {
        this.getFollowings();
        this.getFollowers();
    },
    methods: {
        searchFollowingsUpdate: function (e) {
            this.getFollowings(e.target.value);
        },
        searchFollowersUpdate: function (e) {
            this.getFollowers(e.target.value);
        },
        toggleModal: function () {
            if (this.showModal) {
                this.onClose(this.form);
            }

            this.showModal = !this.showModal;
        },
        checkboxChange: function (field, value) {
            this.form[field] = [value];
        },
        onClose: function () {
            this.showModal = false;
            this.resetSearch();
        },
        resetSearch: function () {
            this.mail_search = '';
            this.mail_search_result = false;
        },
        getFollowers(search = null, page = 1, recordsPerPage = 100) {
            const self = this;
            self.setLoading(true);

            this.api.get(`user/getFollowers?page=${page}&records_per_page=${recordsPerPage}`)
                .then((response) => {
                    if (response.data.success) {
                        this.followers = search ? response.data.users.filter(u => u.display_name.toLowerCase().includes(search)) : response.data.users;
                        this.followers_count = response.data.count;
                    }
                })
                .catch((error) => {
                    self.toast.error('Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))
        },
        getFollowings(search = null, page = 1, recordsPerPage = 100) {
            const self = this;
            self.setLoading(true);

            this.api.get(`user/getFollowed?page=${page}&records_per_page=${recordsPerPage}`)
                .then((response) => {
                    if (response.data.success) {
                        this.followings = search ? response.data.users.filter(u => u.display_name.toLowerCase().includes(search)) : response.data.users;
                        this.followings_count = response.data.count;
                    }
                })
                .catch((error) => {
                    self.toast.error('Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))
        },
        submitInviteMail() {
            const self = this;

            const validateEmail = (e) => String(e)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );

            if (!this.mail_search || !validateEmail(this.mail_search)) {
                return self.toast.error('Inserisci un indirizzo email');
            }
            
            self.setLoading(true);

            this.api.post(`user/inviteByEmail`, { email: this.mail_search })
                .then((response) => {
                    if (response.data.success) {
                        self.mail_search_result = response?.data;
                    }
                })
                .catch((error) => {
                    self.toast.error('Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))
        }
    }
}
